<template>
  <div>
    <span
      v-if="
        (typeof lotFileDocumentID === 'string' || typeof lotFileDocumentID === 'number') &&
          documentID > 0
      "
    >
      <button
        class="button is-info is-light is-small is-outline is-rounded"
        @click.prevent="downloadPdf(lotFileDocumentID)"
      >
        Pdf
      </button>
    </span>
    <span v-else>
      &nbsp;
    </span>
  </div>
</template>

<script>
export default {
  props: {
    lotFileDocumentID: [Number, String],
    documentID: [Number, String],
    downloadPdf: Function
  }
}
</script>
